const heroSection = $('#hero-section');
const heroBGs = heroSection.find('.hero-bg-slider-slide');
const heroBGImages = heroBGs.find('.hero-bg-slider-image');
const heroEmbla = heroSection.find('.embla');
const heroEmblaControlsNode = heroEmbla.find('.embla__controls')
const heroEmblaDotsNode = heroEmbla.find('.embla__dots');
const heroVideoPreview = heroSection.find('.hero-video-preview-parent')
const heroVideoPopup = heroSection.find('.hero-video-preview-popup');
const heroVideoPopupClose = heroVideoPopup.find('.hero-video-preview-popup-close');
const heroVideoPopupBG = heroVideoPopup.find('.hero-video-preview-popup-bg');
const heroVideoPopupInner = heroVideoPopup.find('.hero-video-preview-popup-inner');
let homeEmblaApi, bgLoopTL;
let isHeroInView = true;
let heroTL;

const syncHeroMediaPlayback = () => {
  if (typeof window.setGradientConsumerState === 'function') {
    window.setGradientConsumerState('hero', isHeroInView);
  }

  if (!bgLoopTL) return;

  const isHeroAnimationCompleted = heroTL && heroTL.progress() === 1;
  const shouldRunLoop = isHeroInView && isHeroAnimationCompleted && !document.hidden;

  if (shouldRunLoop) {
    bgLoopTL.resume();
  } else {
    bgLoopTL.pause();
  }
};

const observeHeroMediaPlayback = () => {
  if (!heroSection.length) return;

  const heroNode = heroSection.get(0);
  const updateVisibility = (isVisible) => {
    isHeroInView = isVisible;
    syncHeroMediaPlayback();
  };

  updateVisibility(
    heroNode.getBoundingClientRect().bottom > 0 && heroNode.getBoundingClientRect().top < window.innerHeight
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => updateVisibility(entry.isIntersecting));
    },
    {
      threshold: 0.01,
    }
  );

  observer.observe(heroNode);
  document.addEventListener('visibilitychange', syncHeroMediaPlayback);
};

let tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const showHeroVideoPopup = (player, immediate) => {
  activePlayer = player;

  const popupTL = gsap.timeline({
    paused: true,
    onStart: () => {
      lenis.stop();
    },
    onComplete: () => {
      player.playVideo();

      heroVideoPopupClose.on('click', () => {
        heroVideoPopupClose.off('click');
        popupTL.reverse();
      });
    },
    onReverseComplete: () => {
      lenis.start();
      gsap.set(heroVideoPopup, { pointerEvents: 'none' });

      const url = new URL(window.location);
      url.searchParams.delete('heroVideo');
      window.history.replaceState({}, '', url);

      if (activePlayer) {
        activePlayer.destroy();
        activePlayer = null;
      }
    },
  });

  popupTL.add(
    gsap.set(heroVideoPopup, {
      display: 'flex',
      pointerEvents: 'all',
    }),
    0
  );

  popupTL.add(
    gsap.fromTo(
      heroVideoPopupBG,
      { opacity: 0 },
      {
        opacity: 0.8,
        duration: 0.667,
        ease: 'opacityInEasing',
      }
    ),
    0
  );

  popupTL.add(
    gsap.fromTo(
      heroVideoPopupInner,
      { y: '100vw' },
      {
        y: 0,
        duration: 0.667,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  if(!immediate){
    popupTL.play();
  } else {
    popupTL.progress(1);
  }
};

const heroVideoToPopup = (card, immediate = false) => {
  const cardVideoURL = card.attr('data-video-url');

  const cardVideoID =
    (cardVideoURL.split('v=')[1] || '').split('&')[0] || '';

  const player = new YT.Player('hero-video-preview-player', {
    height: '360',
    width: '640',
    videoId: cardVideoID,
    playerVars: {
      autoplay: 0,
      rel: 0,
    },
    events: {
      onReady: () => showHeroVideoPopup(player, immediate),
    },
  });
};

const addPopupControl = () => {
  heroVideoPreview.on('click', () => heroVideoToPopup(heroVideoPreview))
}

const addHeroGradient = (duration) => {
  const blobFraming = {
    blob1: {
      position: {
        type: '2f',
        currentValue: [-0.5, 0.5],
        frames: [{ frame: 0, value: [-0.5, 0.5] }],
      },
      size: {
        type: '1f',
        currentValue: 0.4,
        frames: [{ frame: 0, value: 0.4 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.6,
        frames: [{ frame: 0, value: 0.6 }],
      },
      color: {
        type: '4f',
        currentValue: [0.051, 0.0666, 0.165, 1],
        frames: [{ frame: 0, value: [0.051, 0.0666, 0.165, 1] }],
      },
    },
    blob2: {
      position: {
        type: '2f',
        currentValue: [1, 1],
        frames: [
          { frame: 0, value: [1.1, -0.1] },
          { frame: 100, value: [1.1, -0.1] },
        ],
      },
      size: {
        type: '1f',
        currentValue: 0.3,
        frames: [{ frame: 0, value: 0.3 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.6,
        frames: [{ frame: 0, value: 0.6 }],
      },
      color: {
        type: '4f',
        currentValue: [0.051, 0.0666, 0.165, 1],
        frames: [{ frame: 0, value: [0.051, 0.0666, 0.165, 1] }],
      },
    },
    blob3: {
      position: {
        type: '2f',
        currentValue: [0.6, 0.2],
        frames: [{ frame: 0, value: [0.6, 0.2] }],
      },
      size: {
        type: '1f',
        currentValue: 0.2,
        frames: [{ frame: 0, value: 0.2 }],
      },
      scale: {
        type: '1f',
        currentValue: 1,
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        type: '1f',
        currentValue: 0,
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.7,
        frames: [{ frame: 0, value: 0.7 }],
      },
      color: {
        type: '4f',
        currentValue: [0.408, 0.588, 0.702, 1],
      },
    },
    blob4: {
      position: {
        type: '2f',
        currentValue: [0.5, 0.2],
        frames: [{ frame: 0, value: [0.5, 0.2] }],
      },
      size: {
        type: '1f',
        currentValue: 0.2,
        frames: [{ frame: 0, value: 0.3 }],
      },
      scale: {
        type: '1f',
        currentValue: 2,
        frames: [{ frame: 0, value: 2 }],
      },
      angle: {
        type: '1f',
        currentValue: -40,
        frames: [{ frame: 0, value: -40 }],
      },
      smooth_step: {
        type: '1f',
        currentValue: 0.4,
        frames: [{ frame: 0, value: 0.4 }],
      },
      color: {
        type: '4f',
        currentValue: [0.408, 0.588, 0.702, 1],
        frames: [{ frame: 0, value: [0.408, 0.588, 0.702, 1] }],
      },
    },
  };
  const gradientTL = gsap.timeline({
    duration: duration,
    paused: true,
    onUpdate() {
      const progress = gradientTL.progress();
      gradientAPI.updateGradientSettingsByFrame(progress, blobFraming, 100);
    },
  });
  return gradientTL;
};

const addHeroAnimation = () => {
  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      syncHeroMediaPlayback();
    },
  });
  const heroDescription = heroSection.find('.hero-description');
  const heroDescriptorCard = heroSection.find('.descriptor-card');
  const heroBtn = heroSection.find('.button-parent');
  const videoPreview = heroSection.find('.hero-video-preview-parent');

  // Hero title: no SplitText (keeps <h1> as LCP candidate). No animation — visible from first paint.
  heroTL.addLabel('step1');
  
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.5');
  //isDesktop() ? heroTL.add(elementInAnimationYWOpacity(videoPreview, '200%', 0, 1, 0.667, 0.667, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.95') : false;
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.9');
  heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');
  return heroTL;
}

const sliderBgAnimation = (currentIndex, duration) => {
  const stepTL = gsap.timeline({paused: true});
  stepTL.add(gsap.fromTo(heroEmblaDotsNode.find('.slider-dot-inner-progress').eq(currentIndex), {
    scaleY: 0,
  }, {
    scaleY: 1,
    duration: duration,
    ease: 'linear'
  }), 0);

  return stepTL;
}

const bgStepLoopAnimation = (currentIndex, duration) => {
  const stepTL = gsap.timeline({paused: true});
  const nextIndex = (currentIndex + 1) % heroBGs.length;

  stepTL.add(gsap.fromTo(heroBGImages.eq(currentIndex), {
    scale: 1.2,
  }, {
    scale: 1,
    duration: duration,
    ease: "power1.inOut"
  }), 0);
  stepTL.add(gsap.fromTo(heroBGImages.eq(nextIndex), {
    scale: 1.4,
  }, {
    scale: 1.2,
    duration: duration,
    ease: "power1.inOut"
  }), 0)
  stepTL.add(gsap.set(heroBGs.eq(currentIndex), { display: 'none' }), duration * 0.4);
  stepTL.add(gsap.set(heroBGs.eq(nextIndex), { display: 'block' }), duration * 0.4);
  return stepTL;
}

const initHeroBgLoop = () => {
  const stepDuration = 4;
  const animationDuration = 0.833

  gsap.set(heroBGs, { display: 'none' })
  gsap.set(heroBGs.eq(0), { display: 'block' })
  
  bgLoopTL = gsap.timeline({paused: true, repeat: -1});
  
  heroBGImages.each(function (index) {
    const sliderStep = $('<button class="slider-dot embla__dot" type="button"><div class="slider-dot-inner"><div class="slider-dot-inner-progress"></div></div></button>');
    heroEmblaDotsNode.append(sliderStep)
    bgLoopTL.add(sliderBgAnimation(index, stepDuration - animationDuration / 2).play(), `${index * stepDuration}`)
    bgLoopTL.add(bgStepLoopAnimation(index, animationDuration).play(), `${index * stepDuration + stepDuration - animationDuration / 2}`)
  })

  gsap.set(heroBGImages.eq(0), { scale: 1.2 })
}

$(window).on('load', function () {
  const [nav] = performance.getEntriesByType('navigation');
  heroTL = addHeroAnimation();
  if (!isLowEndDevice) {
    heroTL.add(addHeroGradient(heroTL.duration()).play(), 0);
  } else {
  }
  initHeroBgLoop();
  observeHeroMediaPlayback();
  addPopupControl();
  pageIn(heroTL, nav, 0, true);
});
